

















































// vendor
import { defineComponent, computed, ref } from "@vue/composition-api";
// project
import { useAssets } from "@/hooks/useAssets";
import { formatDateStringRecent } from "@/utils/text";
import { Study } from "@/psychlab/types/studies";
import * as StudiesAPI from "@/services/api/studies";
import { useRecentStudies } from "./useRecentStudies";
import { Dictionary } from "@/utils/types";
import { useTranslate } from "@lang";
import { Date, Heading } from "@ui";


export default defineComponent({
	components:{
		Date,
		Heading,
	},
	setup(_){

		const loaded = ref(false);
		const assetHooks = useAssets();
		const studies = ref<Study[]>([]);
		const sessionCount = ref<Dictionary<number>>({});
		const days = computed(() => 7);

		const { translate } = useTranslate();

		const activityMessage = computed(() => {
			const ms = translate("message.noActivity");
			return ms.replace("$n", days.value.toString());
		});

		const {
			studies:recentStudies,
			peekDate,
		} = useRecentStudies(studies, days);

		const getBlueprintName = (s:Study) => {
			const a = assetHooks.assets.value.find(a => a._id === s.target.study);
			return a ? a.name : "";
		};

		const getRoute = (id:string) => {
			return {
				name:"Run.Group",
				params:{
					groupId:id
				}
			}
		};

		const loadData = async () => {
			try {
				const r = await StudiesAPI.getStudiesPaginated({
					limit:20,
					page:1,
					"lastVisited[gte]":peekDate.value,
					sort:"-lastVisited",
					select:"name target lastVisited created enabled",
				});
				
				const count = await StudiesAPI.countStudiesSessions(r.studies.map(s => s._id), { "created[gte]":peekDate.value });

				sessionCount.value = count;
				studies.value = r.studies;
			}
			catch(err){}
			loaded.value = true;
		};

		loadData();

		return {
			activityMessage,
			studies:recentStudies,
			loaded,
			sessionCount,
			formatDateStringRecent,
			getRoute,
			getBlueprintName,
			translate,
		};
	}
});

